<div
  class="full-page w-100 h-100"
  [style.background-image]="
    'url(' +
    ('login-registration/login-background.png' | contentAssetImage) +
    ')'
  "
>
  <div class="maintenance-container h-100">
    <div class="text-center">
      <img
        class="logo"
        [src]="'login-registration/phxid.jpg' | contentAssetImage"
        draggable="false"
      />
    </div>

    <div class="maintenance-text bg-white rounded">
      <div class="icon material-icons">engineering</div>
      <h5
        class="text-center text-uppercase fw-bold mt-4 mb-0"
        [innerHTML]="'maintenance.page.title' | translate | markdownTranslate"
      ></h5>
      <p
        class="font-size-14"
        [innerHTML]="'maintenance.page.details' | translate | markdownTranslate"
      ></p>
    </div>
  </div>
</div>
